// Thread Hub — data client
//
// The only network layer. Every call goes to the Hub's own server function
// (netlify/functions/hub.js, rules in src/api/) with the signed-in user's
// Firebase ID token. The browser holds no proxy key, base id or table name:
// it names an action, and the server decides what this person may reach.
import { idToken } from "./auth";

const API_URL = process.env.REACT_APP_API_URL || "/.netlify/functions/hub";

export class HubError extends Error {
  constructor(status, message) { super(message); this.status = status; }
}

async function send(payload, token) {
  return fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(payload),
  });
}

export async function proxyCall(payload) {
  let res = await send(payload, await idToken());
  // An expired or revoked token: fetch a fresh one and try once more.
  if (res.status === 401) res = await send(payload, await idToken(true));
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new HubError(res.status, err.error || `Hub error: ${res.status}`);
  }
  return res.json();
}
